/**
 * How many filters to ask for when loading a table's saved filters and chips.
 *
 * <p>The service pages this endpoint and defaults to 20. Both call sites used to omit a size, so
 * a table holding more than twenty lost the rest — COWBELL_QUOTES has twenty-one, and because the
 * service returns them unsorted, *which* one went missing changed between calls.
 *
 * <p>Generous rather than exact: filters are a person's own saved queries plus a handful of shared
 * chips, so a table reaching this many is a different problem from the one being fixed here.
 */
export const FILTERS_PAGE_SIZE = 200;
